import { Footer } from "@vwfs-bronson/bronson-react"
import { useTranslation } from "react-i18next"

function FooterLinks({footerLinksData}){
    return (
    <>
    {Object.entries(footerLinksData).map(([elementName, elementValues]) => 
      <Footer.ModuleMetaNav.Item
      
      {...(elementName === 'cookiesetting' ? {
        onClick:() => {
          if (typeof window.CookieControl?.open === 'function') {
            window.CookieControl.open()
          }
        }
      }: {

        key: elementValues.url,
        href: elementValues.url,
        linkProps:{ target: '_blank' },
        normalLink: true,
        rel:"noopener noreferrer"
      })}  
      >
        {elementValues.text}
      </Footer.ModuleMetaNav.Item>
    )}
    </>
    )
}

export function FooterContent(){
    const {t} = useTranslation()
    const footerData = t('headlessCms:footer', {returnObjects: true})
    const {copyright, ...footerLinksData} = footerData
    return(
        <Footer id="footer">
            <Footer.ModuleMetaNav
              copyrightText={copyright}
              metaSectionLabel={t('page:footerAriaLabel')}
            >
              <FooterLinks footerLinksData={footerLinksData}/>
            </Footer.ModuleMetaNav>
          </Footer>
    )
}